import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IInHomeCareLicense } from 'app/models/licenses/in-home-care/in-home-care-license';
import { IIhcPublicRecord } from 'app/models/licenses/in-home-care/ihc-public-record';
import { ILicenseRequest } from 'app/models/licenses/license-request';

@Injectable({providedIn: 'root'})
export class InHomeCareLicenseService {
  private api: string = environment.privateApi + 'InHomeCareLicense/';
  private publicApi: string = environment.publicApi + 'InHomeCareReport/';
  public limited: string = 'Limited';
  public basic: string = 'Basic';
  public intermediate: string = 'Intermediate';
  public comprehensive: string = 'Comprehensive';

  private http = inject(HttpClient);

  public createLicense(): Observable<IInHomeCareLicense> {
    return this.http.post<IInHomeCareLicense>(this.api + 'CreateLicense', null);
  }

  public getLicenses(): Observable<IInHomeCareLicense[]> {
    return this.http.get<IInHomeCareLicense[]>(this.api + 'GetLicenses');
  }

  public getParentInfo(entityName: string): Observable<IInHomeCareLicense> {
    return this.http.get<IInHomeCareLicense>(this.api + 'GetParentInfo/' + entityName);
  }

  public checkIfNameValid(entityName: string, licenseId: string): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'CheckIfNameValid/' + encodeURIComponent(entityName), { params: { licenseId } });
  }

  public checkIfValidParent(entityName: string): Observable<boolean>
  {
    return this.http.get<boolean>(this.api + 'CheckIfValidParent/' + entityName);
  }

  public checkIfValidParentNullable(entityName: string): Observable<boolean>
  {
    return this.http.get<boolean>(this.api + 'CheckIfValidParentNullable/' + entityName);
  }

  public checkIfLicenseExists(licenseNumber: string): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'CheckIfLicenseExists/' + licenseNumber);
  }

  public updateLicense(license: IInHomeCareLicense): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateLicense', license);
  }

  public submitLicense(license: IInHomeCareLicense): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'SubmitLicense', license);
  }

  public renewLicense(licenseId: string): Observable<IInHomeCareLicense>{
    return this.http.post<IInHomeCareLicense>(this.api + 'RenewLicense/' + licenseId, null);
  }

  public getPublicRecords(): Observable<IIhcPublicRecord[]>{
    return this.http.get<IIhcPublicRecord[]>(this.publicApi + 'PublicRecords');
  }

  public downloadLicensedAgenciesReport(): Observable<Blob>{
    return this.http.get<Blob>(this.publicApi + "LicensedAgencies", { responseType: 'blob' as 'json' })
  }

  public requestLicense(licenseRequest: ILicenseRequest): Observable<number>{
    return this.http.post<number>(this.api + 'RequestLicense', licenseRequest);
  }

  public getLicenseRequests(): Observable<ILicenseRequest[]>{
    return this.http.get<ILicenseRequest[]>(this.api + 'GetLicenseRequests');
  }

  public cancelLicenseRequest(licenseRequestId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'CancelLicenseRequest/' + licenseRequestId);
  }

  public cancelLicense(licenseId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'CancelLicense/' + licenseId);
  }
}
